import { Alert, Box, Button, Link, TextField } from "@mui/material";
import { useAsyncAction } from "nate-react-api-helpers";
import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { api } from "../../api/API";
import { AccountCard, emailInputProps } from "./AccountCard";

export function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);

    const send = useAsyncAction(async (input: { email: string }) => {
        await api.account.forgotPassword(input);
        setSent(true);
    }, []);

    return (
        <AccountCard title="Reset your password">
            {sent ? (
                <Alert severity="success">
                    If {email} has an account, we sent it a link to reset the password.
                </Alert>
            ) : (
                <form onSubmit={e => {
                    e.preventDefault();
                    send.callback({ email: email });
                }}>
                    <TextField label="Email" autoComplete="username" fullWidth slotProps={emailInputProps}
                               value={email} onChange={e => setEmail(e.target.value)} />
                    <div style={{ height: 16 }} />
                    <Button type="submit" variant="contained" fullWidth disabled={send.loading || !email.trim()}>
                        Send link
                    </Button>
                    {send.LoadingElement}
                </form>
            )}

            <Box sx={{ pt: 2, textAlign: "center" }}>
                <Link component={RouterLink} to="/login" variant="body2">Back to login</Link>
            </Box>
        </AccountCard>
    );
}
